import PropTypes from 'prop-types';
import { createContext, useCallback, useEffect, useState } from 'react';

// project-imports
import { getRoles } from 'actions/roles';

// Fetched once for the authenticated app; every role picker/label reads from
// here via the useRoles() hook, so roles are centralised from the API.
const RolesContext = createContext({ roles: [], loading: true, refresh: () => {} });

export const RolesProvider = ({ children }) => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const res = await getRoles();
    setRoles(res?.data || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <RolesContext.Provider value={{ roles, loading, refresh }}>
      {children}
    </RolesContext.Provider>
  );
};

RolesProvider.propTypes = {
  children: PropTypes.node,
};

export default RolesContext;
